import { AdHocReminderModel } from "./ad-hoc-reminder-model";

export class AdHocPaymentReminderModel extends AdHocReminderModel {
  emails: string[];
  includeInvoice: boolean;
  companyName: string;

  constructor(data: Partial<AdHocPaymentReminderModel>) {
    super(data);

    this.emails = data.emails ?? [];
    this.includeInvoice = data.includeInvoice ?? false;
    this.companyName = data.companyName ?? '';
  }
}
